'use strict';

import Mute from "../../../javascripts/components/Mute";

document.addEventListener('DOMContentLoaded', () => {
  new Mute().addToggleMuteEvent();
});

class CommunityContentView {
  constructor($element) {
    this.$element = $element;
    this.$searchSort = $element.find('.c-SortCondition').find('.js-sort');
    this.$searchSortBy = $element.find('.c-SortCondition').find('.js-sortBy');
    this.$filterMenuTextTitle = $element.find('.js-FilterMenuText_Title');
    this.$defaultSort = $element.find('.c-FormWrapper').find('.c-SortCondition').data('sort')

    // 共通のヘッダー部
    this.$searchForm = $('.c-Search_Form');
    this.$advancedSearchLink = $('.js-AdvancedSearch_Link');

    this.$searchSort.on('change', (e) => {
      this.setSort(e.currentTarget);
    });

    this.$searchSortBy.on('change', (e) => {
      this.setSortBy(e.currentTarget);
    });

    this.$filterMenuTextTitle.on('click', (e) =>{
      this.toggleFilterMenuLists(e.currentTarget);
    });

    this.$filterMenuTextTitle.on('keypress', (e) =>{
      if (e.code == 13) {
        this.toggleFilterMenuLists(e.currentTarget);
        return false;
      }
    });

    this.$searchForm.on('submit', (e) =>{
      e.preventDefault();
      e.target.action = location.origin + '/community_contents/advanced_search'
    });

    this.$advancedSearchLink.on('click', (e) =>{
      this.setKeyword(e.currentTarget);
    });

    this.restore();
  }

  restore() {
    const searchParams = new URLSearchParams(window.location.search);
    const patternMenu = 'search_community_content_advanced[menu_id]';
    const patternSort = 'search_community_content_advanced[sort]';
    const patternSortBy = 'search_community_content_advanced[sort_by]';
    const sortSelector = document.querySelector('.js-sort')
    const sortBySelector = document.querySelector('.js-sortBy')

    searchParams.forEach((val, key) => {
      if(key.indexOf(patternMenu) === 0 && val == 'on'){
        document.querySelectorAll('.js-menu_id').forEach((v) =>{
          if(v.name == key){
            v.checked = true;
          }
        });
      }
      else if(key.indexOf(patternSort) === 0) {
        if (sortSelector) {
          Array.from(sortSelector.options).forEach((v) =>{
            if(v.value == val){
              v.selected = true
            }else{
              v.selected = false
            }
          });
        }
      }
      else if(key.indexOf(patternSortBy) === 0) {
        if (sortBySelector) {
          Array.from(sortBySelector.options).forEach((v) =>{
            if(v.value == val){
              v.selected = true
            }else{
              v.selected = false
            }
          });
        }
      }
    });

    if (!searchParams.get('search_community_content_advanced[sort]')) {
      if(sortSelector) {
        if (this.$defaultSort) {
          sortSelector.value = this.$defaultSort
        } else {
          sortSelector.value = 'created_at'
        }
      }
    }
    if (!searchParams.get('search_community_content_advanced[sort_by]')) {
      if(sortBySelector) {
        sortBySelector.value = 'desc'
      }
    }
  }

  updateQueryParams(targetObject) {
    const searchParams = new URLSearchParams(window.location.search);
    const nextQueryParams = {};
    searchParams.forEach((val, key) => {
      nextQueryParams[key] = val;
    });
    for (const key in targetObject) {
      nextQueryParams[key] = targetObject[key];
    }
    delete nextQueryParams['search_community_content_advanced[page]'];
    location.href = location.origin + location.pathname + `?${this.stringify(nextQueryParams)}`;
  }

  stringify(targetObject) {
    return Object.entries(targetObject).reduce((queries, current) => {
      let key = encodeURIComponent(current[0]);
      let value = encodeURIComponent(current[1]);
      return (queries += (queries === '' ? '' : '&') + `${key}=${value}`);
    }, '');
  }

  setSort(ele) {
    const _targetObject = {};
    _targetObject['search_community_content_advanced[sort]'] = ele.options[ele.options.selectedIndex].value;
    this.updateQueryParams(_targetObject);
  }

  setSortBy(ele) {
    const _targetObject = {};
    _targetObject['search_community_content_advanced[sort_by]'] = ele.options[ele.options.selectedIndex].value;
    this.updateQueryParams(_targetObject);
  }

  setKeyword(ele) {
    const searchForm = document.querySelector('.c-Search_Form')
    if (searchForm) {
      const _targetObject = {};
      _targetObject['search_community_content_advanced[keyword]'] = searchForm['search_community_content_advanced[keyword]'].value;
      this.updateQueryParams(_targetObject);
    }
  }

  toggleFilterMenuLists(ele) {
    const filterMenuLists = document.querySelector('.st-FilterMenuLists')
    if (filterMenuLists) {
      filterMenuLists.classList.toggle('sr-only');
      this.toggleFilterMenu();
    }
  }

  toggleFilterMenu() {
    const filterMenuToggle = document.querySelector('.c-FilterMenuToggle')
    if (filterMenuToggle) {
      filterMenuToggle.classList.toggle('up');
    }
  }
}
$(() => new CommunityContentView($('.js-community_contents_search')));
